import { ReviewTemplate } from './components/review-assessment-sections/review-assessment-sections.component'

const performanceOptions = [
   { label: 'Sets the Standard for Others', value: 'sets_the_standard_for_others' },
   { label: 'Successful', value: 'successful' },
   { label: 'Opportunity for Improvement', value: 'opportunity_for_improvement' },
   { label: 'Not Successful', value: 'not_successful' },
   { label: 'Not Applicable', value: 'not_applicable' },
]

const overallPerformanceOptions = [
   { label: 'Sets the Standard for Others', value: 'sets_the_standard_for_others' },
   { label: 'Successful', value: 'successful' },
   { label: 'Opportunity for Improvement', value: 'opportunity_for_improvement' },
   { label: 'Not Successful', value: 'not_successful' },
]

const coreValueOptions = [
   { label: 'Always', value: 'always' },
   { label: 'Often', value: 'often' },
   { label: 'Sometimes', value: 'sometimes' },
   { label: 'Never', value: 'never' },
]

const goalStatusOptions = [
   { label: 'Achieved', value: 'achieved' },
   { label: 'Partially Achieved', value: 'partially_achieved' },
   { label: 'Not Achieved', value: 'not_achieved' },
]

function staticReviewerText(id: string, html: string) {
   return {
      id,
      type: 'static' as const,
      required: false,
      labelIsHtml: true,
      revieweeLabel: '',
      reviewerLabel: html,
   }
}

export function resolveTemplateTokens_clinical(template: ReviewTemplate, tokens: Record<string, string>): ReviewTemplate {
   const replaceAll = (text: string): string => {
      if (!text) return text
      let result = text
      for (const [token, value] of Object.entries(tokens)) {
         result = result.split(`{{${token}}}`).join(value)
      }
      return result
   }

   return {
      ...template,
      sections: template.sections.map((section) => ({
         ...section,
         questions: section.questions.map((q) => ({
            ...q,
            revieweeLabel: replaceAll(q.revieweeLabel),
            reviewerLabel: replaceAll(q.reviewerLabel),
         })),
      })),
   }
}

export const CLINICAL_REVIEW_TEMPLATE: ReviewTemplate = {
   reviewType: 'CLINICAL',
   sections: [
      {
         id: 'section_job_description',
         revieweeTitle: 'Job Description',
         reviewerTitle: '',

         questions: [
            {
               id: 'job_description_reviewed_team',
               type: 'checkbox',
               required: true,
               options: [{ label: 'I have reviewed my current job description.', value: 'reviewed_current_job_description' }],
               revieweeLabel:
                  'Please review your updated job description using the link below. The job description will open in a new browser tab. After reviewing it, return to this self-assessment (your original tab) and confirm that you’ve reviewed the job description by checking the box below.<span class="required-asterisk">&nbsp;*</span><p></p><p><a href="{{JOB_DESC_URL}}" target="_blank"><i>{{JOB_DESC_TEXT}}</i> &nbsp;&nbsp;<i class="fa fa-external-link-alt"></i></a></p>',
               reviewerLabel: '',
               maxSelections: 1,
               labelIsHtml: true,
            },
         ],
      },

      {
         id: 'section_definitions',
         revieweeTitle: 'Rating Definitions',
         reviewerTitle: 'Rating Definitions',

         questions: [
            {
               id: 'rating_definitions',
               type: 'static',
               labelIsHtml: true,
               revieweeLabel:
                  '<div class="review-definition-list">\n<p><strong>Sets the Standard for Others:</strong> Consistently exceeds expectations and serves as a role model and trainer; others look to this individual for guidance and best practices. <span class="v-redcolor">Requires Comment.</span></p>\n<p><strong>Successful:</strong> Meets expectations and reliably performs responsibilities effectively and independently.</p>\n<p><strong>Opportunity for Improvement:</strong> Meets some expectations but has clear areas needing development to achieve consistent performance.</p>\n<p><strong>Not Successful:</strong> Does not meet expectations; performance gaps significantly impact results and require immediate improvement. <span class="v-redcolor">Requires Comment.</span></p>\n<p><strong>Not Applicable:</strong> This competency or goal is not relevant to the individual\u2019s role.</p>\n</div>',
               reviewerLabel:
                  '<div class="review-definition-list">\n<p><strong>Sets the Standard for Others:</strong> Consistently exceeds expectations and serves as a role model and trainer; others look to this individual for guidance and best practices. <span class="v-redcolor">Requires Comment.</span></p>\n<p><strong>Successful:</strong> Meets expectations and reliably performs responsibilities effectively and independently.</p>\n<p><strong>Opportunity for Improvement:</strong> Meets some expectations but has clear areas needing development to achieve consistent performance.</p>\n<p><strong>Not Successful:</strong> Does not meet expectations; performance gaps significantly impact results and require immediate improvement. <span class="v-redcolor">Requires Comment.</span></p>\n<p><strong>Not Applicable:</strong> This competency or goal is not relevant to the individual\u2019s role.</p>\n</div>',
            },
         ],
      },

      {
         id: 'section_client_service_administration',
         revieweeTitle: 'Client Service & Administration',
         reviewerTitle: 'Client Service & Administration',

         questions: [
            {
               id: 'books_appointments_appropriately',
               type: 'radio',
               required: true,
               labelIsHtml: true,
               revieweeLabel:
                  '<span class="review-subtitle">Appointment & Client Management</span><p></p>When applicable, books appointments appropriately',
               revieweeOptions: performanceOptions,
               reviewerLabel:
                  '<span class="review-subtitle">Appointment & Client Management</span><p></p>When applicable, books appointments appropriately',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'schedules_next_recommended_appointment',
               type: 'radio',
               required: true,
               revieweeLabel: "Makes scheduling the pet's next recommended appointment a priority during client checkout",
               revieweeOptions: performanceOptions,
               reviewerLabel: "Makes scheduling the pet's next recommended appointment a priority during client checkout",
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'communicates_clearly_clients_team',
               type: 'radio',
               required: true,
               labelIsHtml: true,
               revieweeLabel:
                  '<span class="review-subtitle">Client Experience & Communication</span><p></p>Clearly communicates with team members and clients \u2013 in person, phone, email, text, etc.',
               revieweeOptions: performanceOptions,
               reviewerLabel:
                  '<span class="review-subtitle">Client Experience & Communication</span><p></p>Clearly communicates with team members and clients \u2013 in person, phone, email, text, etc.',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'attentive_to_clients',
               type: 'radio',
               required: true,
               revieweeLabel: 'Attentive to clients',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Attentive to clients',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'empathetic_compassionate',
               type: 'radio',
               required: true,
               revieweeLabel: 'Empathetic and Compassionate',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Empathetic and Compassionate',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'manages_client_issues_escalates',
               type: 'radio',
               required: true,
               revieweeLabel: 'Manages client issues and escalates when appropriate',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Manages client issues and escalates when appropriate',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'communicates_payment_options_programs',
               type: 'radio',
               required: true,
               revieweeLabel: 'Communicates available payment options, financing solutions, and hospital programs to clients when applicable',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Communicates available payment options, financing solutions, and hospital programs to clients when applicable',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
         ],
      },

      {
         id: 'section_teamwork_professional_effectiveness',
         revieweeTitle: 'Teamwork & Professional Effectiveness',
         reviewerTitle: 'Teamwork & Professional Effectiveness',

         questions: [
            {
               id: 'collaborates_effectively_hospital_team',
               type: 'radio',
               required: true,
               labelIsHtml: true,
               revieweeLabel:
                  '<span class="review-subtitle">Collaboration & Accountability</span><p></p>Collaborates effectively with veterinarians, technicians, assistants, CCRs, and hospital leadership to support patient care and hospital operations',
               revieweeOptions: performanceOptions,
               reviewerLabel:
                  '<span class="review-subtitle">Collaboration & Accountability</span><p></p>Collaborates effectively with veterinarians, technicians, assistants, CCRs, and hospital leadership to support patient care and hospital operations',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'demonstrates_accountability',
               type: 'radio',
               required: true,
               revieweeLabel:
                  'Demonstrates accountability by completing responsibilities, following through on commitments, and adhering to attendance and scheduling expectations',
               revieweeOptions: performanceOptions,
               reviewerLabel:
                  'Demonstrates accountability by completing responsibilities, following through on commitments, and adhering to attendance and scheduling expectations',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'takes_initiative_creative_solutions',
               type: 'radio',
               required: true,
               labelIsHtml: true,
               revieweeLabel:
                  '<span class="review-subtitle">Initiative & Decision Making</span><p></p>Takes initiative and provides creative suggestions/solutions',
               revieweeOptions: performanceOptions,
               reviewerLabel:
                  '<span class="review-subtitle">Initiative & Decision Making</span><p></p>Takes initiative and provides creative suggestions/solutions',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'considers_options_outcomes',
               type: 'radio',
               required: true,
               revieweeLabel: 'Considers all options and potential outcomes when making a decision',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Considers all options and potential outcomes when making a decision',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'maintains_organized_work_area',
               type: 'radio',
               required: true,
               labelIsHtml: true,
               revieweeLabel: '<span class="review-subtitle">Organization & Productivity</span><p></p>Maintains an organized work area',
               revieweeOptions: performanceOptions,
               reviewerLabel: '<span class="review-subtitle">Organization & Productivity</span><p></p>Maintains an organized work area',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'manages_time_fast_paced',
               type: 'radio',
               required: true,
               revieweeLabel: 'Manages time well and succeeds in a fast-paced, multi-tasking environment',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Manages time well and succeeds in a fast-paced, multi-tasking environment',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'follows_safety_protocols',
               type: 'radio',
               required: true,
               labelIsHtml: true,
               revieweeLabel:
                  '<span class="review-subtitle">Safety & Compliance</span><p></p>Follows hospital safety protocols and promotes a safe environment for team members, clients, and patients',
               revieweeOptions: performanceOptions,
               reviewerLabel:
                  '<span class="review-subtitle">Safety & Compliance</span><p></p>Follows hospital safety protocols and promotes a safe environment for team members, clients, and patients',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'completes_required_training',
               type: 'radio',
               required: true,
               revieweeLabel: 'Completes required training and maintains required certifications and licensure',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Completes required training and maintains required certifications and licensure',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'training_examples',
               type: 'static',
               labelIsHtml: true,
               revieweeLabel:
                  '<p><em>Examples: Dayforce Learning assignments, continuing education (CE), Fear Free Certification, CPR certification, Veterinary Technician Licensure, OSHA training, radiation safety training, development programs, and other role-specific requirements.</em></p>',
               reviewerLabel:
                  '<p><em>Examples: Dayforce Learning assignments, continuing education (CE), Fear Free Certification, CPR certification, Veterinary Technician Licensure, OSHA training, radiation safety training, development programs, and other role-specific requirements.</em></p>',
            },
         ],
      },

      {
         id: 'section_patient_care_animal_handling',
         revieweeTitle: 'Patient Care & Animal Handling',
         reviewerTitle: 'Patient Care & Animal Handling',

         questions: [
            {
               id: 'provides_clinical_care_staying_animals',
               type: 'radio',
               required: true,
               labelIsHtml: true,
               revieweeLabel:
                  '<span class="review-subtitle">Daily Patient Care</span><p></p>Provides clinical care for animals that are staying in the clinic; feeding, grooming, weighing',
               revieweeOptions: performanceOptions,
               reviewerLabel:
                  '<span class="review-subtitle">Daily Patient Care</span><p></p>Provides clinical care for animals that are staying in the clinic; feeding, grooming, weighing',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'monitors_animal_wellbeing',
               type: 'radio',
               required: true,
               revieweeLabel: 'Keeps tabs on the health and wellbeing of animals and reports concerns to the veterinarian when appropriate',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Keeps tabs on the health and wellbeing of animals and reports concerns to the veterinarian when appropriate',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'handles_restrains_animals',
               type: 'radio',
               required: true,
               labelIsHtml: true,
               revieweeLabel: '<span class="review-subtitle">Animal Handling</span><p></p>Handles/Restrains animals during exams/vaccinations',
               revieweeOptions: performanceOptions,
               reviewerLabel: '<span class="review-subtitle">Animal Handling</span><p></p>Handles/Restrains animals during exams/vaccinations',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'calms_cares_for_animals',
               type: 'radio',
               required: true,
               revieweeLabel: 'Calms and cares for animals \u2013 especially those that are upset or scared',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Calms and cares for animals \u2013 especially those that are upset or scared',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'cleans_cages_kennels_baths',
               type: 'radio',
               required: true,
               labelIsHtml: true,
               revieweeLabel:
                  '<span class="review-subtitle">Hospital Cleanliness & Sanitation</span><p></p>Cleans cages and kennels, and baths patients',
               revieweeOptions: performanceOptions,
               reviewerLabel:
                  '<span class="review-subtitle">Hospital Cleanliness & Sanitation</span><p></p>Cleans cages and kennels, and baths patients',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'sterilizes_equipment_sanitary_workspace',
               type: 'radio',
               required: true,
               revieweeLabel: 'Sterilizes equipment and maintains a sanitary workspace',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Sterilizes equipment and maintains a sanitary workspace',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'cleans_sets_up_exam_rooms',
               type: 'radio',
               required: true,
               revieweeLabel: 'Cleans and sets up exam rooms',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Cleans and sets up exam rooms',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
         ],
      },

      {
         id: 'section_clinical_patient_assessment',
         revieweeTitle: 'Clinical Skills - Patient Assessment & Documentation',
         reviewerTitle: 'Clinical Skills - Patient Assessment & Documentation',
         cardGroupId: 'clinical_skills',
         cardGroupTitle: 'Clinical Skills',
         allowSectionNotApplicable: true,

         questions: [
            {
               id: 'collect_reason_vitals',
               type: 'radio',
               required: true,
               revieweeLabel: 'Collect reason for visit and take patient vitals',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Collect reason for visit and take patient vitals',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'initial_assessment_observes_reports',
               type: 'radio',
               required: true,
               revieweeLabel: 'Initial Assessment of patients; observes and reports on the behavior and condition of the animal',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Initial Assessment of patients; observes and reports on the behavior and condition of the animal',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'records_updates_medical_records',
               type: 'radio',
               required: true,
               notApplicableGroup: 'patient_assessment_documentation',
               notApplicableGroupTitle: 'Patient Assessment & Documentation',
               revieweeLabel: 'Records and updates patient medical records',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Records and updates patient medical records',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
         ],
      },

      {
         id: 'section_clinical_diagnostics',
         revieweeTitle: 'Clinical Skills - Diagnostics & Laboratory Procedures',
         reviewerTitle: 'Clinical Skills - Diagnostics & Laboratory Procedures',
         cardGroupId: 'clinical_skills',
         cardGroupTitle: 'Clinical Skills',
         allowSectionNotApplicable: true,

         questions: [
            {
               id: 'collects_processes_lab_samples',
               type: 'radio',
               required: true,
               notApplicableGroup: 'diagnostics_laboratory_procedures',
               notApplicableGroupTitle: 'Diagnostics & Laboratory Procedures',
               showNotApplicableGroupButton: true,
               revieweeLabel: 'Collects and Processes samples for lab work',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Collects and Processes samples for lab work',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'radiology_surgical_preparation',
               type: 'radio',
               required: true,
               notApplicableGroup: 'diagnostics_laboratory_procedures',
               notApplicableGroupTitle: 'Diagnostics & Laboratory Procedures',
               revieweeLabel: 'Radiology and Surgical preparation',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Radiology and Surgical preparation',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'performs_diagnostic_imaging',
               type: 'radio',
               required: true,
               notApplicableGroup: 'diagnostics_laboratory_procedures',
               notApplicableGroupTitle: 'Diagnostics & Laboratory Procedures',
               revieweeLabel: 'Performs diagnostic imaging',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Performs diagnostic imaging',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
         ],
      },

      {
         id: 'section_clinical_medications',
         revieweeTitle: 'Clinical Skills - Medications & Pharmacy',
         reviewerTitle: 'Clinical Skills - Medications & Pharmacy',
         cardGroupId: 'clinical_skills',
         cardGroupTitle: 'Clinical Skills',
         allowSectionNotApplicable: true,

         questions: [
            {
               id: 'administers_vaccinations_medications',
               type: 'radio',
               required: true,
               notApplicableGroup: 'medications_pharmacy',
               notApplicableGroupTitle: 'Medications & Pharmacy',
               showNotApplicableGroupButton: true,
               revieweeLabel: 'Administers vaccinations and medications prescribed by veterinarians',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Administers vaccinations and medications prescribed by veterinarians',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'fills_refills_medications',
               type: 'radio',
               required: true,
               notApplicableGroup: 'medications_pharmacy',
               notApplicableGroupTitle: 'Medications & Pharmacy',
               revieweeLabel: 'Fills/Refills medications prescribed by veterinarians',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Fills/Refills medications prescribed by veterinarians',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'manages_controlled_substances',
               type: 'radio',
               required: true,
               notApplicableGroup: 'medications_pharmacy',
               notApplicableGroupTitle: 'Medications & Pharmacy',
               revieweeLabel: 'Manages controlled substances prescribed by veterinarians according to protocols',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Manages controlled substances prescribed by veterinarians according to protocols',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
         ],
      },

      {
         id: 'section_clinical_surgery_anesthesia',
         revieweeTitle: 'Clinical Skills - Surgery & Anesthesia',
         reviewerTitle: 'Clinical Skills - Surgery & Anesthesia',
         cardGroupId: 'clinical_skills',
         cardGroupTitle: 'Clinical Skills',
         allowSectionNotApplicable: true,

         questions: [
            {
               id: 'prepares_patients_for_surgery',
               type: 'radio',
               required: true,
               notApplicableGroup: 'surgery_anesthesia',
               notApplicableGroupTitle: 'Surgery & Anesthesia',
               showNotApplicableGroupButton: true,
               revieweeLabel: 'Prepares patients for surgery',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Prepares patients for surgery',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'prepares_equipment_for_surgery',
               type: 'radio',
               required: true,
               notApplicableGroup: 'surgery_anesthesia',
               notApplicableGroupTitle: 'Surgery & Anesthesia',
               revieweeLabel: 'Prepares equipment for surgery',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Prepares equipment for surgery',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'assists_with_anesthesia',
               type: 'radio',
               required: true,
               notApplicableGroup: 'surgery_anesthesia',
               notApplicableGroupTitle: 'Surgery & Anesthesia',
               revieweeLabel: 'Assist veterinarians with anesthesia',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Assist veterinarians with anesthesia',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'administers_monitors_anesthesia',
               type: 'radio',
               required: true,
               notApplicableGroup: 'surgery_anesthesia',
               notApplicableGroupTitle: 'Surgery & Anesthesia',
               revieweeLabel: 'Administers and monitors anesthesia',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Administers and monitors anesthesia',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'assists_in_surgical_suite',
               type: 'radio',
               required: true,
               notApplicableGroup: 'surgery_anesthesia',
               notApplicableGroupTitle: 'Surgery & Anesthesia',
               revieweeLabel: 'Assist veterinarians in the surgical suite',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Assist veterinarians in the surgical suite',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
         ],
      },

      {
         id: 'section_clinical_emergency_support',
         revieweeTitle: 'Clinical Skills - Emergency & Veterinary Support',
         reviewerTitle: 'Clinical Skills - Emergency & Veterinary Support',
         cardGroupId: 'clinical_skills',
         cardGroupTitle: 'Clinical Skills',
         allowSectionNotApplicable: true,

         questions: [
            {
               id: 'assists_veterinarians_emergencies',
               type: 'radio',
               required: true,
               revieweeLabel: 'Assist veterinarians during emergencies',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Assist veterinarians during emergencies',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
         ],
      },

      {
         id: 'section_clinical_client_education',
         revieweeTitle: 'Clinical Skills - Client Education',
         reviewerTitle: 'Clinical Skills - Client Education',
         cardGroupId: 'clinical_skills',
         cardGroupTitle: 'Clinical Skills',
         allowSectionNotApplicable: true,

         questions: [
            {
               id: 'educates_pet_parents',
               type: 'radio',
               required: true,
               notApplicableGroup: 'client_education',
               notApplicableGroupTitle: 'Client Education',
               showNotApplicableGroupButton: true,
               revieweeLabel: 'Educates pet parents on the proper health, nutrition, and home care for their animals',
               revieweeOptions: performanceOptions,
               reviewerLabel: 'Educates pet parents on the proper health, nutrition, and home care for their animals',
               reviewerOptions: performanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
         ],
      },

      {
         id: 'section_additional_performance_criteria',
         revieweeTitle: 'Additional Performance Review Criteria',
         reviewerTitle: 'Additional Performance Review Criteria',

         hideWhenNoAnswers: false,
         questions: [],
      },

      {
         id: 'section_core_values',
         revieweeTitle: 'Core Values',
         reviewerTitle: 'Core Values',

         questions: [
            {
               id: 'core_do_the_right_thing',
               type: 'radio',
               required: true,
               revieweeLabel:
                  "Do the Right Thing: I do what's right for our clients and their pets, act with the highest level of integrity, and speak up if something doesn't seem right.",
               revieweeOptions: coreValueOptions,
               reviewerLabel:
                  'Do the Right Thing: Demonstrates integrity, acts in the best interest of clients and their pets, and speaks up when something does not seem right.',
               reviewerOptions: coreValueOptions,
               requiresNotesForValues: ['never'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'core_compassionate_care',
               type: 'radio',
               required: true,
               revieweeLabel:
                  'Provide Compassionate Care: I care deeply about what I do for the clients and animals I serve, and for my team members. I interact with empathy and kindness and put in extra effort to create a comfortable environment for all.',
               revieweeOptions: coreValueOptions,
               reviewerLabel:
                  'Provide Compassionate Care: Consistently demonstrates empathy, kindness, and compassion toward clients, patients, and team members, while contributing to a supportive and comfortable environment.',
               reviewerOptions: coreValueOptions,
               requiresNotesForValues: ['never'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'core_build_community',
               type: 'radio',
               required: true,
               revieweeLabel:
                  'Build Community: I strive to build trusted relationships, foster connections, and create inclusive spaces where everyone is seen, heard, belongs, and is respected and valued.',
               revieweeOptions: coreValueOptions,
               reviewerLabel:
                  'Build Community: Builds trusted relationships, fosters collaboration, and contributes to an inclusive environment where others feel respected, valued, and supported.',
               reviewerOptions: coreValueOptions,
               requiresNotesForValues: ['never'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'core_learning_growth',
               type: 'radio',
               required: true,
               revieweeLabel:
                  'Pursue Learning & Growth: I believe in continuous learning and take an active role in my personal and professional growth and improvement, with the goal of making life even better.',
               revieweeOptions: coreValueOptions,
               reviewerLabel:
                  'Pursue Learning & Growth: Actively seeks opportunities to learn, develop new skills, apply feedback, and contribute to continuous improvement.',
               reviewerOptions: coreValueOptions,
               requiresNotesForValues: ['never'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'core_take_pride',
               type: 'radio',
               required: true,
               revieweeLabel:
                  'Take Pride in Our Work: I am proud of the care and service I provide and strive to be positive and celebrate the impact of my work as well as the work of my teammates.',
               revieweeOptions: coreValueOptions,
               reviewerLabel:
                  'Take Pride in Our Work: Demonstrates pride in the quality of work provided, maintains a positive attitude, and recognizes the contributions and successes of others.',
               reviewerOptions: coreValueOptions,
               requiresNotesForValues: ['never'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
         ],
      },

      {
         id: 'section_general_assessment',
         revieweeTitle: 'General Assessment',
         reviewerTitle: 'General Assessment',

         questions: [
            {
               id: 'top_strengths_successes',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'What do you consider to be your top 3 successes/strengths within this role?',
               reviewerLabel: "What do you consider to be this team member's top 3 strengths or successes during this review period?",
            },
            {
               id: 'areas_of_opportunity',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'What do you consider to be your areas of opportunity within this role?',
               reviewerLabel: "What do you consider to be this team member's primary areas of opportunity?",
            },
            {
               id: 'recognized_accomplishments',
               type: 'textarea',
               required: true,
               maxLength: 1000,
               revieweeLabel: 'Accomplishments I am most proud of this year.',
               reviewerLabel: 'What accomplishments is this team member most recognized for during this review period?',
            },
         ],
      },

      {
         id: 'section_previous_goals',
         revieweeTitle: '',
         reviewerTitle: 'Performance Goals from Last Review Period',

         questions: [
            staticReviewerText(
               'previous_goals_instructions',
               `Summarize the team member's progress against goals set during the prior review period. Indicate whether each goal was achieved, partially achieved, or not achieved, with brief context. (Leave blank if no prior goals were set or this is the team member's first review.)`
            ),
            {
               id: 'previous_review_goals',
               type: 'table',
               required: false,
               maxRows: 5,
               labelIsHtml: true,
               revieweeLabel: '',
               reviewerLabel: '<span class="developmentTitle">Prior Goals</span>',
               tableColumns: [
                  { label: 'Describe Goal', field: 'describeGoal', type: 'textarea' },
                  {
                     label: 'Achieved?',
                     field: 'achieveStatus',
                     type: 'select',
                     options: [
                        { label: 'Yes', value: 'yes' },
                        { label: 'No', value: 'no' },
                        { label: 'Partial', value: 'partial' },
                     ],
                  },
                  { label: 'Brief Context', field: 'briefContext', type: 'textarea' },
               ],
            },
         ],
      },

      {
         id: 'section_overall_rating',
         revieweeTitle: 'Overall Performance Rating',
         reviewerTitle: 'Overall Performance Rating',

         questions: [
            {
               id: 'overall_performance_rating',
               type: 'radio',
               required: true,
               revieweeLabel:
                  'Considering my performance across all competencies and core values during this review period, I would rate my overall performance as:',
               revieweeOptions: overallPerformanceOptions,
               reviewerLabel:
                  "Considering performance across all competencies and core values during this review period, the team member's overall performance is:",
               reviewerOptions: overallPerformanceOptions,
               requiresNotesForValues: ['sets_the_standard_for_others', 'not_successful'],
               notes: { revieweeLabel: 'Optional notes', reviewerLabel: 'Optional notes', maxLength: 1000 },
            },
            {
               id: 'anything_else_hm_should_know',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: 'Anything else I would like my Hospital Manager to know.',
               reviewerLabel: 'Manager Comments',
            },
         ],
      },

      // Performance Goals for Next Review Period
      {
         id: 'section_next_goals',
         revieweeTitle: '',
         reviewerTitle: 'Performance Goals for Next Review Period',
         questions: [
            staticReviewerText(
               'next_goals_instructions',
               `Align goals with hospital priorities, the team member's development opportunities, and career interests.<p></p>Setting goals should be SMART goals (Specific, Measurable, Achievable, Relevant, Time-bound). Consider available Dayforce Learning courses, CE opportunities, on-the-job development opportunities, and other action items. Assign development activities based on the team member's career interests, growth goals, performance opportunities, and business needs.`
            ),
            {
               id: 'development_items',
               type: 'table',
               required: false,
               maxRows: 3,
               labelIsHtml: true,
               revieweeLabel: '',
               reviewerLabel: '<span class="developmentTitle">Development Item(s)</span>',
               tableColumns: [
                  { label: 'Development Goal / Action Item', field: 'developmentGoal', type: 'textarea' },
                  { label: 'Reason for Assignment', field: 'reasonForAssignment', type: 'textarea' },
                  { label: 'Success Measure', field: 'successMeasure', type: 'textarea' },
                  { label: 'Target Completion Date', field: 'targetCompletionDate', type: 'date' },
               ],
            },
         ],
      },

      {
         id: 'section_growth_and_career_path',
         revieweeTitle: 'Opportunities for Growth and Development',
         reviewerTitle: 'Potential Career Interests and Areas for Exploration',

         questions: [
            {
               id: 'growth_interests',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel:
                  'Please list any areas of growth or specific interest related to your role or other roles within the hospital that you would like to explore in the next several months/year.',
               reviewerLabel: '',
            },
            {
               id: 'possible_career_path',
               type: 'textarea',
               required: false,
               maxLength: 1000,
               revieweeLabel: '',
               reviewerLabel:
                  "Based on the team member's current performance, skills, strengths, and interests, identify any roles, responsibilities, experiences, or career areas that may be worth considering for future exploration. (This is not a commitment to a specific opportunity and is separate from the employee's review and development plan.)",
            },
         ],
      },
   ],
}
